import { Link, useLocation } from "wouter";
import {
  LayoutDashboard,
  Server,
  Search,
  FileText,
  Shield,
  Settings,
  MessagesSquare,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { useUIStore } from "@/stores/ui";

const NAV_ITEMS = [
  { href: "/chat", icon: MessagesSquare, label: "aiZam Chat" },
  { href: "/dashboard", icon: LayoutDashboard, label: "Главная" },
  { href: "/investigations", icon: Search, label: "Сбор данных" },
  { href: "/reports", icon: FileText, label: "Отчёты" },
  { href: "/services", icon: Server, label: "Сервисы" },
  { href: "/audit", icon: Shield, label: "Журнал" },
  { href: "/settings", icon: Settings, label: "Настройки" },
];

export function Sidebar() {
  const [location] = useLocation();
  const { sidebarOpen, toggleSidebar } = useUIStore();

  return (
    <aside
      className={cn(
        "flex h-full flex-col border-r border-border bg-card transition-all duration-200",
        sidebarOpen ? "w-60" : "w-16",
      )}
    >
      <div className="flex h-16 items-center justify-between border-b border-border px-4">
        {sidebarOpen && (
          <div className="flex items-center gap-2">
            <img
              src="/brand/aglobex-mark.png"
              alt=""
              width={137}
              height={100}
              className="h-8 w-auto shrink-0 object-contain"
            />
            <div className="flex flex-col gap-0.5 leading-tight">
              <span className="text-sm font-semibold">WOW-OSINT</span>
              <span className="text-[10px] font-medium uppercase leading-none tracking-[0.14em] text-muted-foreground">
                экосистема Aglobex
              </span>
              <span className="text-[10px] leading-none text-orange-500/90">Всё связано</span>
            </div>
          </div>
        )}
        <button
          onClick={toggleSidebar}
          className="flex h-6 w-6 items-center justify-center rounded text-muted-foreground hover:bg-accent hover:text-foreground"
        >
          {sidebarOpen ? <ChevronsLeft className="h-4 w-4" /> : <ChevronsRight className="h-4 w-4" />}
        </button>
      </div>

      <nav className="flex-1 space-y-1 p-2">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = location.startsWith(item.href);
          return (
            <Link key={item.href} href={item.href}>
              <a
                className={cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors",
                  active
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:bg-accent hover:text-foreground",
                )}
              >
                <Icon className="h-4 w-4 shrink-0" />
                {sidebarOpen && <span className="truncate">{item.label}</span>}
              </a>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
